import { Component, OnInit } from '@angular/core';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import {FormsModule} from '@angular/forms';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Swal from 'sweetalert2';

export interface DialogData
{
    tipoCarga: any
    recarga: boolean
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Component({
  selector: 'app-listado-pendientes',
  templateUrl: '../../pages/listado-pendientes/listado-pendientes.component.html',
  styleUrls: ['../../pages/listado-pendientes/listado-pendientes.component.css']
})
export class ListadoPendientesComponent implements OnInit 
{
    rol:string = localStorage.getItem("rol")
    idUsuario:string =localStorage.getItem("idUsuario")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
     identificadorDeTemporizador: any
    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
    //data: any = {message:""}

    cargaMasiva: any = { tipoCarga:null,  idUsuario:null, archivo: File = null, }
 
    agrupadorProductos: any = []
    currentDate: any
    botonActivo: any = true
    
    allComplete: boolean = false

    constructor(private AfiliacionService: AfiliacionService, private postulacionesService: PostulacionesService,
                private dialog: MatDialog) { }

    ngOnInit(): void 
    {
        let vm = this      
        this.loadData()
    }

    loadData()
    {
        let vm = this
    }
    
   
    verArchivo(postulacionId: any)
    {
        let vm = this
    
        this.postulacionesService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`             
                    window.open(fileURL);
                })  
               
            }
        )
        .catch 
        ( 
            error =>  
            {
                console.log(error)

                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )        
    }
  

    csvInputChange(fileInputEvent: any) { 

        this.cargaMasiva.archivo = fileInputEvent.target.files[0] 
    }
  
    pendienteAfiliacion()
    {
     
      var vm = this
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();

        this.AfiliacionService.retornaExcelPendientes().then
        (
            (data: any) =>
            {
                this.AfiliacionService.getFileNameUrl(data.message).then
                (
                    (archivos: any) =>
                    {   
                            var fileURL=archivos.url        
                            window.open(fileURL);
                       Swal.close();              
                    }
                )
                .catch
                (
                    (error) =>
                    {
                        console.log(error)
                        vm.openAlertDialog('Ha ocurrido un error para generar el archivo.', 'btn-danger')
                    }
                )
               
            }
        )
        .catch
        (
            (error) =>
            {
                console.log(error)
                vm.openAlertDialog('Ha ocurrido un error para generar el archivo.', 'btn-danger')
            }
        )
 
    }

    
    pendienteDesaAfiliacion()
    {
        var vm = this
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
  
          this.AfiliacionService.retornaExcelPendientesDesafiliacion().then
          (
              (data: any) =>
              {
                  this.AfiliacionService.getFileNameUrl(data.message).then
                  (
                      (archivos: any) =>
                      {   
                              var fileURL=archivos.url        
                              window.open(fileURL);
                         Swal.close();              
                      }
                  )
                  .catch
                  (
                      (error) =>
                      {
                          console.log(error)
                          vm.openAlertDialog('Ha ocurrido un error para generar el archivo.', 'btn-danger')
                      }
                  )
                 
              }
          )
          .catch
          (
              (error) =>
              {
                  console.log(error)
                  vm.openAlertDialog('Ha ocurrido un error para generar el archivo.', 'btn-danger')
              }
          )
       
    }


    openAlertDialog(mensaje: string, clase: string)  
    {
        const dialogRef = this.dialog.open(AlertDialogComponent, 
        {
            data: 
            {              
                message: mensaje,
                clase: clase,
                buttonText: { cancel: 'Listo!' },
            }
        })
    }

    pageChanged(event: any) 
    { 
        this.config.currentPage = event 
        
        this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )
    }
}